var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstadoButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_733_43377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_733_43377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5C4.16667 12.5 3.45833 12.2086 2.87499 11.6258C2.29166 11.043 2 10.3353 2 9.50272C2 8.67014 2.29166 7.96153 2.87499 7.37692C3.45833 6.7923 4.16667 6.5 5 6.5H11C11.8333 6.5 12.5417 6.7914 13.125 7.3742C13.7083 7.95701 14 8.66471 14 9.49729C14 10.3299 13.7083 11.0385 13.125 11.6231C12.5417 12.2077 11.8333 12.5 11 12.5H5ZM5 11.9H11C11.66 11.9 12.225 11.665 12.695 11.195C13.165 10.725 13.4 10.16 13.4 9.5C13.4 8.84 13.165 8.275 12.695 7.805C12.225 7.335 11.66 7.1 11 7.1H5C4.34 7.1 3.775 7.335 3.305 7.805C2.835 8.275 2.6 8.84 2.6 9.5C2.6 10.16 2.835 10.725 3.305 11.195C3.775 11.665 4.34 11.9 5 11.9ZM10.9986 11C11.4149 11 11.7692 10.8543 12.0615 10.5629C12.3538 10.2715 12.5 9.91765 12.5 9.50135C12.5 9.08506 12.3543 8.73077 12.0629 8.43847C11.7715 8.14616 11.4176 8 11.0014 8C10.5851 8 10.2308 8.1457 9.93847 8.4371C9.64616 8.72851 9.5 9.08236 9.5 9.49865C9.5 9.91494 9.6457 10.2692 9.9371 10.5615C10.2285 10.8538 10.5824 11 10.9986 11Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstadoButton);
export default __webpack_public_path__ + "static/media/estado-button.97e25c116c4a46c41736866c812b2fca.svg";
export { ForwardRef as ReactComponent };